window.addEventListener("load", function() {
    $(".hide__center").on("click", function(e) {
        e.preventDefault();
        $(".main-left-h5").toggleClass("hidden");
        $(this).toggleClass("open");
    });
});